<template>
  <div>
    <div style="position: relative;">
      <h2 class="text-center font-weight-light">
        Bản đồ nông nghiệp Tiền Giang
      </h2>
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-chip
          @click="getMapTrongTrot()"
          class="mr-2"
          :class="$vuetify.breakpoint.lgAndUp ? '' : 'agrimap-type-mob'"
          :color="trongTrotMap ? 'primary' : ''"
          :text-color="trongTrotMap ? 'white' : ''"
        >
          <v-icon v-if="trongTrotMap" left>
            mdi-layers-outline
          </v-icon>
          Bản đồ trồng trọt
        </v-chip>
        <v-chip
          @click="getMapChanNuoi()"
          class="mr-2"
          :class="$vuetify.breakpoint.lgAndUp ? '' : 'agrimap-type-mob'"
          :color="chanNuoiMap ? 'primary' : ''"
          :text-color="chanNuoiMap ? 'white' : ''"
        >
          <v-icon v-if="chanNuoiMap" left>
            mdi-layers-outline
          </v-icon>
          Bản đồ chăn nuôi
        </v-chip>
      </v-col>
      <v-col cols="12" md="6" class="text-right">
        <v-chip 
          :href="url"
          target="_blank"
          class="mr-2"
          :class="$vuetify.breakpoint.lgAndUp ? '' : 'agrimap-type-mob'"
        >
          <v-icon left>
            mdi-web
          </v-icon>
          Quản lý GIS
        </v-chip>
      </v-col>
      <v-col cols="12">
        <!-- <iframe 
          class="embed-responsive-item" 
          :src="`${url}/embed/${account}/${key}`" 
          allowfullscreen 
          width="100%" 
          height="700px" 
          style="border: 0;"
        /> -->
        <iframe 
          class="embed-responsive-item" 
          :src="`${url}/guest/ban-do/${key}`" 
          allowfullscreen 
          width="100%" 
          height="700px" 
          style="border: 0;"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    data: () => ({
      trongTrotMap: true,
      chanNuoiMap: false,
      url: null,
      account: null,
      key: 'VTT'
    }),
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted(){
      this.url = this.config.gisMap.url;
      this.account = this.config.gisMap.account;
    },
    methods: {
      getMapTrongTrot () {
        this.trongTrotMap = true;
        this.chanNuoiMap = false;
        this.key = 'VTT';
      },
      getMapChanNuoi () {
        this.trongTrotMap = false;
        this.chanNuoiMap = true;
        this.key = 'VCN';
      }
    }
  }
</script>
<style>
  .v-progress-linear--absolute{
    z-index: 3 !important;
  }
  .agrimap-type-mob{
    width: 100%;
    margin-top: 8px;
    justify-content: center;
  }
</style>